import { Button } from '@alefeducation/ui-elements-library-core';
import { PlusCircleSolid } from '@alefeducation/ui-elements-library-icons';
import React from 'react';
import styled from 'styled-components';
import { useHistory, useParams } from 'react-router-dom';
import { ADD_MEMBER_BUTTON_TEXT } from '../../utils/constants';
import useIframeAuth from '../../pages/hooks/useIframeAuth';
import { ROUTE_ORGANISATIONS } from '../Routing/routeHelpers';

const StyledAddMemberButtonContainer = styled.div`
  justify-content: flex-end;
`;

const AddMemberButton = () => {
  const { code } = useParams<{ code: string }>();
  const history = useHistory();
  const { isAuthorized } = useIframeAuth({ isFromMembersPage: true });

  const shouldRenderAddMemberButton = () =>
    isAuthorized('create:user') || isAuthorized('assign:user');

  const redirectToAddMember = () => {
    const path = ROUTE_ORGANISATIONS.addMember.replace(':code', code);
    history.push(path, {
      pageNumber: 0,
    });
  };

  const onClick = React.useCallback(redirectToAddMember, []);

  if (shouldRenderAddMemberButton()) {
    return (
      <StyledAddMemberButtonContainer>
        <Button icon={<PlusCircleSolid />} onClick={onClick}>
          {ADD_MEMBER_BUTTON_TEXT}
        </Button>
      </StyledAddMemberButtonContainer>
    );
  }
  return <React.Fragment />;
};

export default AddMemberButton;
